import * as React from 'react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Clock } from 'lucide-react';
import { cn } from '@/lib/utils';

interface TimeSelectProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

// Generate time slots in 30-minute intervals
const generateTimeSlots = () => {
  const slots: string[] = [];
  for (let hour = 6; hour <= 23; hour++) {
    slots.push(`${hour.toString().padStart(2, '0')}:00`);
    slots.push(`${hour.toString().padStart(2, '0')}:30`);
  }
  return slots;
};

const TIME_SLOTS = generateTimeSlots();

export function TimeSelect({ value, onChange, placeholder = 'Seleccionar hora', disabled, className }: TimeSelectProps) {
  const [open, setOpen] = React.useState(false);

  const handleSelect = (time: string) => {
    onChange(time);
    setOpen(false);
  };

  const formatDisplayTime = (time: string) => {
    if (!time) return placeholder;
    return time;
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          disabled={disabled}
          className={cn(
            'w-full justify-between font-normal',
            !value && 'text-muted-foreground',
            className
          )}
        >
          <span className="flex items-center gap-2">
            <Clock className="h-4 w-4" />
            {formatDisplayTime(value)}
          </span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[280px] p-3 bg-popover" align="start">
        <div className="grid grid-cols-4 gap-1.5">
          {TIME_SLOTS.map((time) => (
            <Button
              key={time}
              variant={value === time ? 'default' : 'outline'}
              size="sm"
              className={cn(
                'h-10 text-sm font-medium touch-manipulation',
                value === time && 'bg-primary text-primary-foreground'
              )}
              onClick={() => handleSelect(time)}
            >
              {time}
            </Button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
